import { Component, inject, TemplateRef } from '@angular/core';

//SUB COMPONENTS
import { HeaderComponent } from '@components/dashboard/header/header.component';
import { NavComponent } from '@components/dashboard/navigation/nav.component';
import { DashboardService } from '@services/dashboard.service';
import { Document, Booking, WithdrawalRequest, TopupRequest, updateDocumentForm } from '@interfaces/models.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbDateStruct, NgbDatepickerModule, NgbAlertModule, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { Apollo } from 'apollo-angular';
import { GoogleMapsModule, GoogleMap } from '@angular/google-maps';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { cloneDeepWith, cloneDeep } from 'lodash';
import { AuthStore } from '@store/auth.store';
import { BaseCoreUtils } from '@core/base-core-util';
import { ModuleNames } from '@enums/module-names';
import { PARTNER_DETAIL, PARTNER_BOOKING_EXPRESS_TXNS, PARTNER_BOOKING_RIDE_TXNS, PARTNER_WITHDRAWAL_REQUESTS, PARTNER_TOPUP_REQUESTS, PARTNER_ACTIVITY_HISTORY } from '@gql_queries/partners/queries';
import { UPDATE_PARTNER_DOCUMENT, APPROVE_PARTNER_ACCOUNT, CREATE_PARTNER_DOCUMENT, DELETE_PARTNER_DOCUMENT, SEND_FOLLOW_UP_NOTIFICATION, UPDATE_PARTNER_ACCOUNT_STATUS, UPDATE_PARTNER_DOCUMENT_BY_ID } from '@gql_queries/partners/mutation';
import { ToastrService } from 'ngx-toastr';
import adminOverride from '@core/admin-override.json';

@Component({
    selector: 'app-dashboard-rider-details',
    standalone: true,
    templateUrl: './dashboard-rider-details.component.html',
    styleUrl: './dashboard-rider-details.component.css',
    imports: [NgbDatepickerModule, NgbAlertModule, HeaderComponent, NavComponent, CommonModule, FormsModule, RouterModule, MomentModule, GoogleMapsModule, GoogleMap, NgxImageZoomModule],
})

export class DashboardRiderDetailsComponent {
    private coreUtils!: BaseCoreUtils;
    private modalService = inject(NgbModal);
    private offcanvasService = inject(NgbOffcanvas);

    imageSrc?: string | ArrayBuffer | null;
    today = new Date();
    model?: NgbDateStruct = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
    dateToday: Date;
    dateSevenDaysAgo: Date;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private dasher: DashboardService,
        private apollo: Apollo,
        private authStore: AuthStore,
        private toastr: ToastrService
    ) {
        this.coreUtils = new BaseCoreUtils({
            module: ModuleNames.PARTNERS,
            apollo: this.apollo,
            router: this.router,
            authStore: this.authStore,
        });
        this.dateToday = new Date();
        this.dateSevenDaysAgo = new Date(this.today);
        this.dateSevenDaysAgo.setDate(this.today.getDate() - 7);
    }

    profileImage: string = '../../../../assets/okito/images/avatar.png';
    clickableProfileImage: boolean = false;

    public searchKeywordWithdrawal: string = '';
    public searchKeywordTopup: string = '';
    public searchKeywordBooking: string = '';

    public disableActionBtnsBooking: any = {
        next: false,
        prev: false,
    };

    public disableActionBtnsWithdrawals: any = {
        next: false,
        prev: false,
    };

    public disableActionBtnsTopups: any = {
        next: false,
        prev: false,
    };

    /** Activity History tab: one page of this partner's audited changes. */
    public activityHistory: any[] = [];
    public activityPage: number = 1;
    public activityTotalPages: number = 1;
    public activityTotal: number = 0;
    public readonly activityPageSize: number = 10;
    public activityLoading: boolean = false;

    public currentPageBooking: number = 1;
    public currentPageWithdrawals: number = 1;
    public currentPageTopups: number = 1;

    public detailViewed: Record<string, any> = {};
    public isLoadingDetail: boolean = true;
    public detailTabs: Record<string, any> = {
        personal: true,
        service_details: false,
        documents: false,
        transactions: false,
        topups: false,
        withdrawals: false,
        activity: false
    }
    public documentDictionary: Record<string, any> = {
        selfie: 'Selfie Photo',
        id: 'ID',
        medical_certificate: 'Medical Certificate',
        tnvs_certificate: 'TNVS Certification',
        insurance: 'Insurance',
        vehicle_registration: 'Vehicle Registration',
        vehicle_photo: 'Vehicle Photo',
        drivers_license: 'Driver`s License',
        nbi_certificate: 'NBI Certificate',
        gcash_settlement: 'G-CASH Settlement',
        spa_letter: 'Authorization/SPA Letter',
        drug_test_certificate: 'Drug Test Certificate',
        driving_track_certificate: 'Driving / Track Pass Certificate',
        no_modification_certification: 'No Modification Certificate',
        truck_permit: 'Truck Permit',
        tnvs_affiliate: 'Affiliation',
        pemdes_mwl: 'PEMDES MWL',
    }

    public subDocumentDictionary: Record<string, any> = {
        front: 'Front Side',
        back: 'Back Side',
        right: 'Right Side',
        left: 'Left Side',
        official_receipt: 'Official Receipt',
        certificate_registration: 'Certificate of Registration',
    }

    public formDocumentType: Record<string, any> = {
        selfie: false,
        id: false,
        medical_certificate: false,
        spa_letter: false,
        tnvs_certificate: false,
        gcash_settlement: false,
        nbi_certificate: false,
        truck_permit: false,
        insurance: {
            front: false,
            back: false
        },
        drivers_license: {
            front: false,
            back: false
        },
        vehicle_registration: {
            official_receipt: false,
            certificate_registration: false
        },
        vehicle_photo: {
            front: false,
            right: false,
            left: false,
            back: false,
        },
        drug_test_certificate: false,
        driving_track_certificate: false,
        no_modification_certification: false,
    }
    currentSelectedDocument = '';
    selectedDocInfo: Document = {
        partnerDocumentId: '',
        idNumber: '',
        firstName: '',
        middleName: '',
        lastName: '',
        isDone: false,
        link: '',
        status: 0,
        type: '',
        subType: '',
        address: '',
        dateCreated: '',
        expirationDate: '',
        birthdate: null,
        dateApprove: null,
        gender: false,
        notes: '',
    };

    public confirmSelection: Record<string, any> = {
        amend: false,
        verify_doc: false,
        verify_partner: false,
        remove_doc: false,
        follow_up: false,
    }

    public enableEdit: boolean = false;
    public isValidatingDocument: boolean = false;

    public documentUpdateMode: boolean = false;
    public overridePassword: string = '';
    public overridePasswordError: string = '';
    public isUpdatingDocumentDetails: boolean = false;
    public isEditingDocument: boolean = false;

    partnerBookings: Booking[] = [];
    public bookingdetailViewed: Record<string, any> = {};
    public withdrawdetailViewed: Record<string, any> = {};
    public topupdetailViewed: Record<string, any> = {};

    //FOR THE MAP (BOOKING DETAILS)
    polyLinePath: google.maps.LatLng[] = [];
    display: any;
    center: google.maps.LatLngLiteral = {
        lat: 22.2736308,
        lng: 70.7512555
    };
    zoom = 15;
    polyLineOptions: google.maps.PolylineOptions = {
        strokeColor: '#D81960',
        strokeOpacity: 1.0,
        strokeWeight: 5,
        clickable: false,
        editable: false,
        visible: true,
        geodesic: true,
    };

    public detailViewdDocuments: Document[] = [];

    public withdrawalList: WithdrawalRequest[] = [];
    public currentSelectedPageListWithdrawals: WithdrawalRequest[] = [];

    public topUpList: TopupRequest[] = [];
    public currentSelectedPageListTopups: TopupRequest[] = [];

    public dayViewWithdrawals: Record<string, any> = {
        days_7: true,
        days_30: false,
    };

    public dayViewtopUps: Record<string, any> = {
        days_7: true,
        days_30: false,
    };

    documentPhoto: File | null = null;

    public documentFormNew: Record<string, any> = {
        partnerId: '',
        type: '',
        subType: '',
        link: '',
        status: 'pending'
    }

    /**
     * The slot chosen in the Add Document modal, as "type::subType" — one
     * <select> value for what is really a pair. "ID / front" and "ID / back"
     * are different documents, so the type alone does not identify a slot.
     */
    public selectedDocumentSlot: string = '';

    public documentForRemoval: Document = {
        partnerDocumentId: '',
        idNumber: '',
        firstName: '',
        middleName: '',
        lastName: '',
        isDone: false,
        link: '',
        status: 0,
        type: '',
        subType: '',
        address: '',
        dateCreated: '',
        expirationDate: '',
        birthdate: null,
        dateApprove: null,
        gender: false,
        notes: '',
    };

    bookingSortBy: string = 'dateCreated';
    bookingSortDirection: string = 'desc';
    currentBookingSelectedPageListTopups: Booking[] = [];

    selectedServiceType: string = 'express';

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            const partnerId = params.get('partnerId');
            if (!partnerId) {
                this.router.navigate(['/admin/riders']);
                return;
            }
            this.loadPartnerDetail(partnerId);
        });
    }

    loadPartnerDetail(partnerId: string) {
        this.isLoadingDetail = true;

        this.coreUtils.viewDetail(PARTNER_DETAIL, {
            ids: [partnerId],
        }, (data) => {
            const partner = data['partners']?.[0];
            if (!partner) {
                this.router.navigate(['/admin/riders']);
                return;
            }

            this.isLoadingDetail = false;

            this.clickableProfileImage = false;
            this.detailViewed = cloneDeepWith(partner, (value) => {
                if (value && value.__typename) {
                    const { __typename, ...rest } = value;
                    return rest;
                }
            });
            this.detailViewed = cloneDeep(this.detailViewed);
            this.detailViewdDocuments = cloneDeepWith(partner.partnerDocuments, (value) => {
                if (value && value.__typename) {
                    const { __typename, ...rest } = value;
                    return rest;
                }
            });
            this.detailViewdDocuments = cloneDeep(this.detailViewdDocuments);

            const selfieDoc = this.detailViewdDocuments.filter(doc => doc.type === 'selfie')[0];
            if (selfieDoc && selfieDoc.link != '' && selfieDoc.isDone == true && selfieDoc.status == 'approve') {
                this.profileImage = selfieDoc.link;
                this.clickableProfileImage = true;
            }

            // Transactions / Topup / Withdrawals load when their tab is opened
            // — see loadActiveTabData(). Opening a partner used to fire three
            // list queries nobody had asked for yet.
            this.loadActiveTabData();
        });
    }


    get partnerVehicle(): any {
        const vehicles = this.detailViewed?.['partnerVehicles'];
        return Array.isArray(vehicles) && vehicles.length > 0 ? vehicles[0] : null;
    }

    get fleetRegistry(): any {
        return this.detailViewed?.['fleetRegistry'] || null;
    }

    /**
     * Whether the admin can add a document right now.
     *
     * Deliberately not the approval gate this button used to share: that one is
     * false once a partner is approved, which made Add Document dead on exactly
     * the records that need a late addition (a renewed licence, a drug test).
     * Adding a document slot is safe at any stage — it starts Pending and still
     * goes through review.
     */
    get canAddDocument(): boolean {
        return !!this.detailViewed?.['partnerId'] && this.addableDocuments.length > 0;
    }

    /** "type::subType" key for a document slot. */
    private slotKey(type: string, subType: string): string {
        return `${type}::${subType}`;
    }

    /**
     * Every document slot that can exist, as type → its parts, or null when the
     * document has no parts and its subType equals its type (selfie/selfie).
     *
     * Deliberately its own list rather than a read of `formDocumentType`: that
     * one is mutable view state for the document modal, and it calls ID a
     * single-part document while every ID on file is stored as id/front plus
     * id/back.
     */
    private readonly documentSlotCatalogue: Record<string, string[] | null> = {
        selfie: null,
        id: ['front', 'back'],
        drivers_license: ['front', 'back'],
        vehicle_registration: ['official_receipt', 'certificate_registration'],
        vehicle_photo: ['front', 'back', 'left', 'right'],
        insurance: ['front', 'back'],
        tnvs_certificate: null,
        tnvs_affiliate: null,
        nbi_certificate: null,
        gcash_settlement: null,
        spa_letter: null,
        medical_certificate: null,
        truck_permit: null,
        pemdes_mwl: null,
        drug_test_certificate: null,
        driving_track_certificate: null,
        no_modification_certification: null,
    };

    /**
     * Document slots this partner does not have yet.
     *
     * Slots the partner already holds are filtered out so the admin cannot
     * create a duplicate — the API refuses one anyway, but a dropdown that
     * offers an impossible choice is its own bug.
     */
    get addableDocuments(): { value: string; label: string }[] {
        const taken = new Set(
            (this.detailViewdDocuments || []).map((doc: any) =>
                this.slotKey(doc.type, doc.subType),
            ),
        );

        const slots: { value: string; label: string }[] = [];

        Object.keys(this.documentSlotCatalogue).forEach((type) => {
            const subTypes = this.documentSlotCatalogue[type] ?? [type];

            subTypes.forEach((subType) => {
                const key = this.slotKey(type, subType);
                if (taken.has(key)) return;

                const typeLabel = this.documentDictionary[type] || type;
                const partLabel = this.subDocumentDictionary[subType];
                slots.push({
                    value: key,
                    label: partLabel ? `${typeLabel} — ${partLabel}` : typeLabel,
                });
            });
        });

        return slots;
    }

    get partnerAuditTrails(): any[] {
        return this.detailViewed?.['auditTrails'] || [];
    }

    documentHistory(doc: Document): any[] {
        return (doc.history || []) as any[];
    }

    documentHistoryWithLinks(doc: Document): any[] {
        const chronological = [...this.documentHistory(doc)].sort(
            (a, b) => new Date(a.dateCreated).getTime() - new Date(b.dateCreated).getTime()
        );
        return chronological.map((entry, index) => ({
            ...entry,
            oldLink: entry.link,
            newLink: (index + 1 < chronological.length) ? chronological[index + 1].link : doc.link,
        }));
    }

    documentAuditTrail(doc: Document): any[] {
        return this.partnerAuditTrails.filter((entry) => entry.partnerDocumentId === doc.partnerDocumentId);
    }

    hasDocumentTrail(doc: Document): boolean {
        return this.documentHistory(doc).length > 0 || this.documentAuditTrail(doc).length > 0;
    }

    documentLabelForId(partnerDocumentId: string | null | undefined): string {
        if (!partnerDocumentId) {
            return 'Account';
        }
        const doc = this.detailViewdDocuments.find((d) => d.partnerDocumentId === partnerDocumentId);
        if (!doc) {
            return 'Account';
        }
        const name = this.verifyDocumentName(doc.type);
        const part = (doc.type === doc.subType) ? '' : this.subDocumentDictionary[doc.subType];
        return part ? `${name} (${part})` : name;
    }

    documentThumbForId(partnerDocumentId: string | null | undefined): string | null {
        if (!partnerDocumentId) {
            return null;
        }
        const doc = this.detailViewdDocuments.find((d) => d.partnerDocumentId === partnerDocumentId);
        return doc?.link || null;
    }

    combinedDocumentTrail(doc: Document): { kind: 'history' | 'audit'; dateCreated: string; entry: any; isLatest?: boolean }[] {
        const combined = [
            ...this.documentHistoryWithLinks(doc).map((entry) => ({ kind: 'history' as const, dateCreated: entry.dateCreated, entry })),
            ...this.documentAuditTrail(doc).map((entry) => ({ kind: 'audit' as const, dateCreated: entry.dateCreated, entry })),
        ];
        combined.sort((a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime());
        if (combined.length) {
            (combined[0] as any).isLatest = true;
        }
        return combined;
    }

    public selectedHistoryDoc: Document | null = null;
    public selectedHistoryEntries: any[] = [];

    viewDocumentHistory(modal: TemplateRef<any>, doc: Document) {
        this.selectedHistoryDoc = doc;
        this.selectedHistoryEntries = this.documentHistory(doc);
        this.modalService.open(modal, { size: 'xl', backdrop: 'static' });
    }

    viewAccountAuditTrail(modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'lg', backdrop: 'static' });
    }

    /** Readable names for audit actions; anything unmapped is title-cased. */
    private readonly auditActionLabels: Record<string, string> = {
        DOCUMENT_CREATE: 'Document Added',
        DOCUMENT_DELETE: 'Document Removed',
        DOCUMENT_UPDATE: 'Document Updated',
        PROFILE_UPDATE: 'Profile Updated',
        AFFILIATE_SETTINGS_UPDATE: 'Affiliate Settings Updated',
    };

    historyActionLabel(action: string): string {
        return (
            this.auditActionLabels[action] ??
            action
                .replace(/^DOCUMENT_/, '')
                .replace(/_/g, ' ')
                .toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase())
        );
    }

    fieldLabel(key: string): string {
        return key
            .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
            .replace(/^./, (c) => c.toUpperCase());
    }

    private safeParseJson(value: string): Record<string, any> {
        try {
            const parsed = JSON.parse(value);
            return (parsed && typeof parsed === 'object') ? parsed : {};
        } catch {
            return {};
        }
    }

    private formatFieldValue(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '—';
        }
        return String(value);
    }

    private isImageField(key: string, value: any): boolean {
        if (typeof value !== 'string' || !value) {
            return false;
        }
        return key === 'link' || /\.(png|jpe?g|gif|webp)(\?|$)/i.test(value);
    }

    auditFieldChanges(entry: { oldValues: string; newValues: string }): { label: string; oldValue: string; newValue: string; isImage: boolean }[] {
        const oldObj = this.safeParseJson(entry.oldValues);
        const newObj = this.safeParseJson(entry.newValues);
        const keys = Array.from(new Set([...Object.keys(oldObj), ...Object.keys(newObj)]));
        return keys.map((key) => ({
            label: this.fieldLabel(key),
            oldValue: this.formatFieldValue(oldObj[key]),
            newValue: this.formatFieldValue(newObj[key]),
            isImage: this.isImageField(key, oldObj[key]) || this.isImageField(key, newObj[key]),
        }));
    }

    get isTaxiService(): boolean {
        return !!this.partnerVehicle?.isTaxi;
    }

    /**
     * Services for the Service Type checkboxes, as the union over the
     * partner's vehicles (the same rule as the partners list), in the order
     * the backend's service availability lists them.
     */
    get serviceTypeOptions(): { id: string; label: string; checked: boolean }[] {
        const vehicles: any[] = this.detailViewed?.['partnerVehicles'] ?? [];
        const holds = (flag: string) => vehicles.some((vehicle) => vehicle?.[flag] === true);
        return [
            { id: 'chkServiceExpress', label: 'Courier/Express', checked: holds('isExpress') },
            { id: 'chkServiceOkRide', label: 'OK! Ride (TNVS)', checked: holds('isOkRide') },
            { id: 'chkServiceMototaxi', label: 'MotoTaxi', checked: holds('isMototaxi') },
            { id: 'chkServiceOkTaxi', label: 'OK! Taxi', checked: holds('isTaxi') },
        ];
    }

    get enrollmentStatusLabel(): string {
        const status = this.fleetRegistry?.status;
        if (!status) {
            return 'Not Enrolled';
        }
        const labels: Record<string, string> = {
            active: 'Enrolled',
            pending: 'Pending',
            inactive: 'Inactive',
            released: 'Released',
        };
        return labels[status] || status;
    }

    get plateOrConductionNumber(): string {
        const registry = this.fleetRegistry;
        if (registry?.plateNumber) {
            return registry.plateNumber;
        }
        if (registry?.conductionNumber) {
            return registry.conductionNumber;
        }
        return this.partnerVehicle?.licensePlate
            || this.detailViewed?.['licensePlate']
            || '';
    }

    get fleetOperatorName(): string {
        return this.fleetRegistry?.fleet?.operatorName || '';
    }

    get vehicleCategory(): string {
        return this.partnerVehicle?.vehicle?.category || '';
    }

    get vehicleTypeLabel(): string {
        return this.fleetRegistry?.vehicleType || '';
    }

    get vehicleMake(): string {
        return this.fleetRegistry?.vehicleMaker || '';
    }

    get vehicleModel(): string {
        return this.fleetRegistry?.vehicleModel || '';
    }

    get vehicleYear(): string {
        const year = this.fleetRegistry?.yearModel;
        return year != null && year !== '' ? String(year) : '';
    }

    openVehicleDetailsModal(modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
    }

    returnToList() {
        this.router.navigate(['/admin/riders']);
    }

    setTabPanelActive(panelIndex: string) {
        Object.keys(this.detailTabs).forEach((x) => {
            this.detailTabs[x] = false;
        });
        this.detailTabs[panelIndex] = true;
        this.loadActiveTabData();
    }

    /** The tab currently showing, or 'personal' before anything is chosen. */
    private activeTab(): string {
        return Object.keys(this.detailTabs).find((tab) => this.detailTabs[tab]) || 'personal';
    }

    /**
     * Fetch the active tab's list, every time it is opened, so an admin who
     * approves a top-up and comes back sees the new state rather than whatever
     * was fetched when the page opened.
     *
     * Each tab refetches with its own current filters — the day range it is
     * set to, the service type Transactions is on — so switching away and back
     * does not quietly reset them.
     */
    loadActiveTabData() {
        const partnerId = this.detailViewed['partnerId'];
        if (!partnerId) return;

        switch (this.activeTab()) {
            case 'transactions':
                this.currentPageBooking = 1;
                this.fetchTransactions(this.selectedServiceType);
            break;

            case 'topups':
                this.currentPageTopups = 1;
                this.setDaysBetween(this.dayViewtopUps['days_30'] ? 30 : 7);
                this.fetchTopupRequests(
                    'all', '', null, partnerId,
                    this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday),
                );
            break;

            case 'activity':
                this.fetchActivityHistory(1);
            break;

            case 'withdrawals':
                this.currentPageWithdrawals = 1;
                this.setDaysBetween(this.dayViewWithdrawals['days_30'] ? 30 : 7);
                this.fetchWithdrawalRequests(
                    'all', partnerId,
                    this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday),
                );
            break;
        }
    }

    verifyDocumentName(document_index: string) {
        return this.documentDictionary[document_index];
    }

    nextPrevBooking(action: string) {
        switch (action) {
            case 'next':
                this.fetchTransactions(this.selectedServiceType, 'next');
            break;

            case 'prev':
                this.fetchTransactions(this.selectedServiceType, 'prev');
            break;
        }
    }

    nextPrevWithdrawals(action: string) {
        switch (action) {
            case 'next':
                this.fetchWithdrawalRequests('all', this.detailViewed['partnerId'], this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday), 'next');
            break;

            case 'prev':
                this.fetchWithdrawalRequests('all', this.detailViewed['partnerId'], this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday), 'prev');
            break;
        }
    }

    nextPrevTopups(action: string) {
        switch (action) {
            case 'next':
                this.fetchTopupRequests('all', '', null, this.detailViewed['partnerId'], this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday), 'next');
            break;

            case 'prev':
                this.fetchTopupRequests('all', '', null, this.detailViewed['partnerId'], this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday), 'prev');
            break;
        }
    }

    searchDataBooking(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.searchKeywordBooking = inputElement.value;

        if (this.searchKeywordBooking.trim() === '') {
            this.currentBookingSelectedPageListTopups = this.partnerBookings;
        } else {
            this.currentBookingSelectedPageListTopups = this.partnerBookings.filter(object => {
                const searchInObject = (obj: any): boolean => {
                    for (const key in obj) {
                        const value = obj[key];
                        if (value == null) continue;
                        if (typeof value === 'object') {
                            if (searchInObject(value)) return true;
                        } else if (value.toString().toLowerCase().includes(this.searchKeywordBooking.toLowerCase())) {
                            return true;
                        }
                    }
                    return false;
                };
                return searchInObject(object);
            });
        }
    }

    searchTopUpData(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.searchKeywordTopup = inputElement.value;

        if (this.searchKeywordTopup.trim() === '') {
            this.currentSelectedPageListTopups = this.topUpList;
        } else {
            this.currentSelectedPageListTopups = this.topUpList.filter(object =>
                Object.values(object).some(value =>
                    (value ? value.toString().toLowerCase() : '').includes(this.searchKeywordTopup.toLowerCase())
                )
            );
        }
    }

    searchWithdrawalData(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.searchKeywordWithdrawal = inputElement.value;

        if (this.searchKeywordWithdrawal.trim() === '') {
            this.currentSelectedPageListWithdrawals = this.withdrawalList;
        } else {
            this.currentSelectedPageListWithdrawals = this.withdrawalList.filter(object =>
                Object.values(object).some(value =>
                    (value ? value.toString().toLowerCase() : '').includes(this.searchKeywordWithdrawal.toLowerCase())
                )
            );
        }
    }

    fetchWidthdrawalsByDateRange(daysBetweenToday: number) {
        this.setDaysBetween(daysBetweenToday);
        if (daysBetweenToday == 7) {
            this.dayViewWithdrawals['days_7'] = true;
            this.dayViewWithdrawals['days_30'] = false;
        } else {
            this.dayViewWithdrawals['days_7'] = false;
            this.dayViewWithdrawals['days_30'] = true;
        }
        this.fetchWithdrawalRequests('all', this.detailViewed['partnerId'], this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday));
    }

    fetchWTopUpsByDateRange(daysBetweenToday: number) {
        this.setDaysBetween(daysBetweenToday);
        if (daysBetweenToday == 7) {
            this.dayViewtopUps['days_7'] = true;
            this.dayViewtopUps['days_30'] = false;
        } else {
            this.dayViewtopUps['days_7'] = false;
            this.dayViewtopUps['days_30'] = true;
        }
        this.fetchTopupRequests('all', '', null, this.detailViewed['partnerId'], this.formatDate(this.dateSevenDaysAgo), this.formatDate(this.dateToday));
    }

    setDaysBetween(datesBetween: number) {
        this.dateToday = new Date();
        this.dateSevenDaysAgo = new Date(this.today);
        this.dateSevenDaysAgo.setDate(this.today.getDate() - datesBetween);
    }

    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    fetchTransactions(servicetype: string = 'express', action: string = '') {
        var fromPage = 1;

        if (action != '') {
            fromPage = this.currentPageBooking;
            switch (action) {
                case 'next':
                    this.currentPageBooking++
                break;

                case 'prev':
                    if (this.currentPageBooking != 1) {
                        this.currentPageBooking--
                    }
                break;
            }
        }

        if (servicetype == 'express') {
            this.coreUtils.viewDetail(PARTNER_BOOKING_EXPRESS_TXNS, {
                partnerId: this.detailViewed['partnerId'],
                page: this.currentPageBooking,
                sortBy: {
                    sort: this.bookingSortBy,
                    direction: this.bookingSortDirection
                } as any,
            }, (data) => {
                this.partnerBookings = [];
                if (data?.bookingExpressTxns?.length !== 0) {
                    this.partnerBookings = data.bookingExpressTxns;
                    this.currentBookingSelectedPageListTopups = this.partnerBookings;
                } else {
                    this.currentPageBooking = fromPage;
                }
            });
        } else {
            this.coreUtils.viewDetail(PARTNER_BOOKING_RIDE_TXNS, {
                page: this.currentPageBooking,
                service: servicetype,
                partnerId: this.detailViewed['partnerId'],
                sortBy: {
                    sort: this.bookingSortBy,
                    direction: this.bookingSortDirection
                } as any,
            }, (data) => {
                this.partnerBookings = [];
                if (data?.bookingRideTxns?.length !== 0) {
                    this.partnerBookings = data.bookingRideTxns;
                    this.currentBookingSelectedPageListTopups = this.partnerBookings;
                } else {
                    this.currentPageBooking = fromPage;
                }
            });
        }
    }

    viewBookingDetails(details: Booking, offcanvas: TemplateRef<any>, selectedServiceType: string) {
        this.bookingdetailViewed = details;
        if (selectedServiceType == 'express') {
            if (details.orderRoutes != '') {
                this.polyLinePath = google.maps.geometry.encoding.decodePath(details.orderRoutes);
                const bounds = new google.maps.LatLngBounds();
                this.polyLinePath.forEach((coordinate: google.maps.LatLng) => {
                    bounds.extend(coordinate);
                });
                this.center = bounds.getCenter().toJSON();
            }
        } else {
            if (details.routes != '') {
                this.polyLinePath = google.maps.geometry.encoding.decodePath(details.routes);
                const bounds = new google.maps.LatLngBounds();
                this.polyLinePath.forEach((coordinate: google.maps.LatLng) => {
                    bounds.extend(coordinate);
                });
                this.center = bounds.getCenter().toJSON();
            }
        }
        this.offcanvasService.open(offcanvas, { position: 'end' });
    }

    viewWithdrawDetails(details: WithdrawalRequest, offcanvas: TemplateRef<any>) {
        this.withdrawdetailViewed = details;
        this.offcanvasService.open(offcanvas, { position: 'end' });
    }

    viewTopupDetails(details: TopupRequest, offcanvas: TemplateRef<any>) {
        this.topupdetailViewed = details;
        this.offcanvasService.open(offcanvas, { position: 'end' });
    }

    validateThisDocument(modal: TemplateRef<any>, action_id: number, rider_id: string, document_details: Document) {
        if (this.isValidatingDocument) {
            return;
        }

        let updateDocForm: updateDocumentForm = {
            partnerId: rider_id,
            partnerDocumentId: document_details.partnerDocumentId,
            idNumber: document_details.idNumber,
            lastName: document_details.lastName,
            link: document_details.link,
            middleName: document_details.middleName,
            status: document_details.status,
            subType: document_details.subType,
            type: document_details.type,
            address: document_details.address,
            expirationDate: document_details.expirationDate,
            firstName: document_details.firstName,
            // Staging added gender to the validation form; the .html and the
            // Document interface already carry it through this merge.
            gender: typeof document_details.gender === 'boolean' ? document_details.gender : false,
            // The column's default is ""; older rows hold NULL and the
            // update mutation wants a string either way.
            notes: document_details.notes ?? ''
        }

        switch (action_id) {
            case 0:
                updateDocForm.status = 'pending';
            break;

            case 1:
                if ((document_details.type == 'drivers_license' && document_details.subType == 'front') || (document_details.type == 'vehicle_registration' && document_details.subType == 'official_receipt') || (document_details.type == 'vehicle_registration' && document_details.subType == 'certificate_registration') || (document_details.type == 'insurance' && document_details.subType == 'front') || (document_details.type == 'insurance' && document_details.subType == 'back')) {
                    let pubdate = this.model?.year + '-' + ((this.model!.month.toString().length > 1) ? this.model!.month : '0' + this.model!.month) + '-' + ((this.model!.day.toString().length > 1) ? this.model!.day : '0' + this.model!.day);
                    updateDocForm.expirationDate = pubdate.toString();
                }
                updateDocForm.status = 'approve';
            break;

            case 2:
                updateDocForm.status = 'ammendment';
            break;

            case 3:
                updateDocForm.status = 'resubmission';
        }

        this.isValidatingDocument = true;

        this.coreUtils.update(UPDATE_PARTNER_DOCUMENT, {
            updatePartnerDocumentInput: updateDocForm
        }, (data) => {
            this.isValidatingDocument = false;

            if (data['updatePartnerDocument'] != null) {
                let completeInstance = data['updatePartnerDocument'];

                this.detailViewdDocuments = this.detailViewdDocuments.map(doc => {
                    if (doc.partnerDocumentId === updateDocForm.partnerDocumentId) {
                        return {
                            ...doc,
                            address: completeInstance.address,
                            birthdate: completeInstance.birthdate,
                            dateApprove: completeInstance.dateApprove,
                            dateCreated: completeInstance.dateCreated,
                            expirationDate: completeInstance.expirationDate,
                            firstName: completeInstance.firstName,
                            gender: completeInstance.gender,
                            idNumber: completeInstance.idNumber,
                            lastName: completeInstance.lastName,
                            link: completeInstance.link,
                            middleName: completeInstance.middleName,
                            partnerDocumentId: completeInstance.partnerDocumentId,
                            status: completeInstance.status,
                            type: completeInstance.type
                        };
                    }
                    return doc;
                });

                this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
            }
        });
    }

    viewDocument(modal: TemplateRef<any>, docInfo: any, editMode: boolean = false) {
        this.isEditingDocument = editMode;
        this.currentSelectedDocument = docInfo.type;
        this.selectedDocInfo = cloneDeepWith(docInfo, (value) => {
            if (value && (value.__typename || value.isDone)) {
                const { __typename, isDone, ...rest } = value;
                return rest;
            }
        });

        this.selectedDocInfo = cloneDeep(this.selectedDocInfo);

        if (!this.selectedDocInfo.notes) {
            this.selectedDocInfo.notes = '';
        }

        // Prefill Expiration Date / Date Issued pickers when a value exists
        this.setDocumentDateModel(this.selectedDocInfo.expirationDate);

        Object.keys(this.formDocumentType).forEach((x) => {
            switch (x) {
                case 'selfie': case 'tnvs_certificate': case 'nbi_certificate': case 'gcash_settlement': case 'spa_letter':
                case 'drug_test_certificate': case 'driving_track_certificate': case 'no_modification_certification':
                case 'id': case 'medical_certificate': case 'truck_permit':
                    this.formDocumentType[x] = false;
                break;

                case 'drivers_license': case 'vehicle_registration': case 'vehicle_photo': case 'insurance':
                    Object.keys(this.formDocumentType[x]).forEach((y) => {
                        this.formDocumentType[x][y] = false;
                    });
                break;
            }
        });

        switch (docInfo.type) {
            case 'selfie': case 'tnvs_certificate': case 'nbi_certificate': case 'gcash_settlement': case 'spa_letter':
            case 'drug_test_certificate': case 'driving_track_certificate': case 'no_modification_certification':
            case 'id': case 'medical_certificate': case 'truck_permit':
                this.formDocumentType[docInfo.type] = true;
            break;

            case 'drivers_license': case 'vehicle_registration': case 'vehicle_photo': case 'insurance':
                this.formDocumentType[docInfo.type][docInfo.subType] = true;
            break;
        }

        this.modalService.open(modal, { size: 'lg' });
    }

    setDocumentDateModel(dateValue: string | null | undefined): void {
        const parsedDate = this.parseToNgbDate(dateValue);

        if (parsedDate) {
            this.model = parsedDate;
            return;
        }

        // Fall back to today when expirationDate / date issued is null
        this.model = {
            year: this.today.getFullYear(),
            month: this.today.getMonth() + 1,
            day: this.today.getDate(),
        };
    }

    parseToNgbDate(dateValue: string | null | undefined): NgbDateStruct | null {
        if (!dateValue) {
            return null;
        }

        const datePart = dateValue.split('T')[0].split(' ')[0];
        const parts = datePart.split('-');

        if (parts.length !== 3) {
            return null;
        }

        const year = Number(parts[0]);
        const month = Number(parts[1]);
        const day = Number(parts[2]);

        if (!year || !month || !day) {
            return null;
        }

        return { year, month, day };
    }

    showConfirmModal(modal: TemplateRef<any>, confirmModalIndex: string) {
        // Re-check state here so a button re-enabled via devtools still
        // can't open the approval confirmation for an approved partner
        if (confirmModalIndex === 'verify_partner' && !this.checkIfAvailableforApproval()) {
            return;
        }

        Object.keys(this.confirmSelection).forEach((x) => {
            this.confirmSelection[x] = false;
        });
        this.confirmSelection[confirmModalIndex] = true;
        this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
    }

    closeAllModals() {
        Object.keys(this.confirmSelection).forEach((x) => {
            this.confirmSelection[x] = false;
        });
        this.modalService.dismissAll();
    }

    openOverrideModal(modal: TemplateRef<any>) {
        this.overridePassword = '';
        this.overridePasswordError = '';
        this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
    }

    submitOverridePassword(modal: any) {
        if (this.overridePassword === adminOverride.password) {
            this.documentUpdateMode = true;
            this.overridePassword = '';
            this.overridePasswordError = '';
            modal.close();
            this.toastr.success('Document update mode enabled', 'Success', { closeButton: true, timeOut: 3000 });
        } else {
            this.overridePasswordError = 'Incorrect password';
            this.toastr.error('Incorrect password', 'ERR', { closeButton: true, timeOut: 3000 });
        }
    }

    endDocumentUpdateMode() {
        this.documentUpdateMode = false;
    }

    editDocument(modal: TemplateRef<any>, docInfo: any) {
        this.viewDocument(modal, docInfo, true);
    }

    updateDocumentDetailsById() {
        if (this.isUpdatingDocumentDetails) {
            return;
        }

        this.isUpdatingDocumentDetails = true;

        this.coreUtils.update(UPDATE_PARTNER_DOCUMENT_BY_ID, {
            updatePartnerDocumentByIdInput: {
                partnerDocumentId: this.selectedDocInfo.partnerDocumentId,
                idNumber: this.selectedDocInfo.idNumber,
                firstName: this.selectedDocInfo.firstName,
                middleName: this.selectedDocInfo.middleName,
                lastName: this.selectedDocInfo.lastName,
                address: this.selectedDocInfo.address,
                expirationDate: this.selectedDocInfo.expirationDate,
                gender: typeof this.selectedDocInfo.gender === 'boolean' ? this.selectedDocInfo.gender : false,
                notes: this.selectedDocInfo.notes
            }
        }, (data) => {
            this.isUpdatingDocumentDetails = false;

            if (data['updatePartnerDocumentById'] != null) {
                let completeInstance = data['updatePartnerDocumentById'];

                this.detailViewdDocuments = this.detailViewdDocuments.map(doc => {
                    if (doc.partnerDocumentId === completeInstance.partnerDocumentId) {
                        return {
                            ...doc,
                            address: completeInstance.address,
                            birthdate: completeInstance.birthdate,
                            expirationDate: completeInstance.expirationDate,
                            firstName: completeInstance.firstName,
                            gender: completeInstance.gender,
                            idNumber: completeInstance.idNumber,
                            lastName: completeInstance.lastName,
                            middleName: completeInstance.middleName,
                            notes: completeInstance.notes
                        };
                    }
                    return doc;
                });

                this.toastr.success('Document details updated', 'Success', { closeButton: true, timeOut: 3000 });
                this.modalService.dismissAll();
            } else {
                this.toastr.error('Failed to update document details, please try again', 'ERR', { closeButton: true, timeOut: 3000 });
            }
        });
    }

    enableEditForm() {
        this.enableEdit = true;
    }

    disableEditForm() {
        this.enableEdit = false;
    }

    updateThisDetails() {
        this.dasher.updatePartner(this.detailViewed['partnerId'], this.detailViewed).subscribe((res) => {
            alert(res.message);
            this.disableEditForm();
        });
    }

    viewLargerModal(modalLarger: TemplateRef<any>) {
        this.modalService.open(modalLarger, { size: 'lg', backdrop: 'static' });
    }

    checkIfAvailableforApproval(type: string = 'partner_approval') {
        let notDoneDocuments = 0;
        let documentException: any[] = [];

        if (type == 'document_confirmation') {
            documentException = ['tnvs_certificate', 'drug_test_certificate', 'driving_track_certificate', 'no_modification_certification'];
        } else {
            documentException = ['tnvs_certificate'];
        }

        if (this.detailViewed['status'] == 'approved') {
            return false;
        }

        if (this.detailViewdDocuments.length != 0) {
            this.detailViewdDocuments.forEach((doc: Document) => {
                if (!documentException.includes(doc.type)) {
                    if (doc.status != 'approve') {
                        notDoneDocuments++;
                    }
                }
            });
        } else {
            return false;
        }

        if (notDoneDocuments != 0) {
            return false;
        } else {
            return true;
        }
    }

    moveMap(event: google.maps.MapMouseEvent) {
        if (event.latLng != null) this.center = (event.latLng.toJSON());
    }

    move(event: google.maps.MapMouseEvent) {
        if (event.latLng != null) this.display = event.latLng.toJSON();
    }

    fetchWithdrawalRequests(status: string, partnerId: string, dateStart: string, dateEnd: string, action: string = '') {
        var fromPage = 1;

        if (action != '') {
            fromPage = this.currentPageWithdrawals;
            switch (action) {
                case 'next':
                    this.currentPageWithdrawals++
                break;

                case 'prev':
                    if (this.currentPageWithdrawals != 1) {
                        this.currentPageWithdrawals--
                    }
                break;
            }
        }

        this.coreUtils.viewDetail(PARTNER_WITHDRAWAL_REQUESTS, {
            status: status,
            page: this.currentPageWithdrawals,
            withdrawalWalletFilterInput: {
                partnerId: partnerId
            },
            dateFilterInput: {
                dateStart: dateStart,
                dateEnd: dateEnd
            },
        }, (data) => {
            if (data['withdrawalRequests'] != null) {
                this.withdrawalList = data['withdrawalRequests'];
                this.currentSelectedPageListWithdrawals = this.withdrawalList;
            }
        });
    }

    fetchTopupRequests(status: string, source: string, topupRequestID: any, partnerId: string, dateStart: string, dateEnd: string, action: string = '') {
        var fromPage = 1;

        if (action != '') {
            fromPage = this.currentPageTopups;
            switch (action) {
                case 'next':
                    this.currentPageTopups++
                break;

                case 'prev':
                    if (this.currentPageTopups != 1) {
                        this.currentPageTopups--
                    }
                break;
            }
        }

        this.coreUtils.viewDetail(PARTNER_TOPUP_REQUESTS, {
            status: "all",
            source: "all",
            page: this.currentPageTopups,
            topUpRequestId: null,
            partnerFilter: {
                partnerId: partnerId
            },
            dateFilterInput: {
                dateStart: dateStart,
                dateEnd: dateEnd
            }
        }, (data) => {
            if (data['topupRequestList'] != null) {
                this.topUpList = data['topupRequestList'];
                this.currentSelectedPageListTopups = this.topUpList;
            }
        });
    }

    showAddDocumentModal(modal: TemplateRef<any>) {
        this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
    }

    onFileSelected(event: any): void {
        const file: File = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageSrc = e.target.result;
            };
            reader.readAsDataURL(file);
            this.documentPhoto = file;
        }
    }

    createDocumentData(confirmModal: TemplateRef<any>) {
        if (!this.selectedDocumentSlot) {
            alert('Please choose a document to add.');
            return;
        }

        const [type, subType] = this.selectedDocumentSlot.split('::');
        this.documentFormNew['type'] = type;
        this.documentFormNew['subType'] = subType;
        this.documentFormNew['partnerId'] = this.detailViewed['partnerId'];

        // The dropdown only offers free slots, so this catches a stale page
        // rather than a mis-click; the API makes the same check transactionally.
        const alreadyHas = (this.detailViewdDocuments || []).some(
            (doc: any) => doc.type === type && doc.subType === subType,
        );
        if (alreadyHas) {
            alert('This partner already has that document.');
            return;
        }

        if (!this.documentPhoto) {
            alert('Please upload the document photo.');
            return;
        }

        this.modalService.open(confirmModal, { size: 'md', backdrop: 'static', keyboard: false });
    }

    proceedCreateDocumentData(successModal: TemplateRef<any>) {
        const formData: any = new FormData();
        if (this.documentPhoto) {
            formData.append('file', this.documentPhoto, this.documentPhoto.name);
        }

        this.dasher.uploadPhoto(formData, 'partner_documents').subscribe((res: any) => {
            this.documentFormNew['link'] = res.photo;

            this.coreUtils.create(CREATE_PARTNER_DOCUMENT, {
                createPartnerDocumentInput: this.documentFormNew
            }, (data) => {
                this.documentFormNew = {
                    partnerId: '',
                    type: '',
                    subType: '',
                    link: '',
                    status: 'pending'
                };

                if (data['createPartnerDocument'] != null) {
                    this.selectedDocumentSlot = '';
                    this.documentPhoto = null;
                    this.imageSrc = undefined;
                    // Re-read the partner so the table and the audit trail both
                    // show the new document, rather than pushing a row locally
                    // and leaving the trail stale.
                    this.loadPartnerDetail(this.detailViewed['partnerId']);
                    this.modalService.open(successModal, { size: 'md', backdrop: 'static', keyboard: false });
                }
            });
        });
    }

    confirmRemoveDoc(doc: Document, confirmModal: TemplateRef<any>) {
        this.documentForRemoval = doc;
        Object.keys(this.confirmSelection).forEach((x) => {
            this.confirmSelection[x] = false;
        });
        this.confirmSelection['remove_doc'] = true;
        this.modalService.open(confirmModal, { size: 'md', backdrop: 'static', keyboard: false });
    }

    removeDocument(doc: Document, successModal: TemplateRef<any>) {
        const partnerId = this.detailViewed['partnerId'];

        this.coreUtils.update(DELETE_PARTNER_DOCUMENT, {
            partnerDocumentId: doc.partnerDocumentId,
            // Scopes the delete to the partner whose page this is; the API
            // refuses an id belonging to anyone else.
            partnerId: partnerId,
        }, (data) => {
            if (data['deletePartnerDocument'] != null) {
                this.detailViewdDocuments = this.detailViewdDocuments.filter((x) => x.partnerDocumentId != doc.partnerDocumentId);
                // The delete is audited, so re-read to pick the entry up.
                this.loadPartnerDetail(partnerId);
                this.modalService.open(successModal, { size: 'md', backdrop: 'static', keyboard: false });
            }
        });
    }

    /**
     * One page of the partner's activity history.
     *
     * Server-paginated: the page the admin is looking at is the only one
     * fetched, and `total` describes the whole history rather than the page.
     */
    fetchActivityHistory(page: number = 1) {
        const partnerId = this.detailViewed['partnerId'];
        if (!partnerId) return;

        this.activityLoading = true;
        this.coreUtils.viewDetail(PARTNER_ACTIVITY_HISTORY, {
            partnerId: partnerId,
            page: page,
            limit: this.activityPageSize,
        }, (data) => {
            this.activityLoading = false;
            const history = data?.['partnerActivityHistory'];
            if (!history) return;

            this.activityHistory = history.items ?? [];
            this.activityPage = history.page ?? page;
            this.activityTotalPages = history.totalPages ?? 1;
            this.activityTotal = history.total ?? 0;
        }, () => {
            this.activityLoading = false;
        });
    }

    nextPrevActivity(action: string) {
        const next = action === 'next' ? this.activityPage + 1 : this.activityPage - 1;
        if (next < 1 || next > this.activityTotalPages) return;
        this.fetchActivityHistory(next);
    }

    /**
     * Only the fields that actually moved.
     *
     * The audit payload carries every field the write touched, so a document
     * delete lists Id Number "— → —" and friends. The column is called What
     * Changed; unchanged rows do not belong in it.
     */
    activityChanges(entry: any): { label: string; oldValue: string; newValue: string; isImage: boolean }[] {
        return this.auditFieldChanges(entry).filter(
            (change) => change.oldValue !== change.newValue,
        );
    }

    /** Green for added, red for removed, neutral for an edit. */
    activityActionClass(action: string): string {
        switch (action) {
            case 'DOCUMENT_CREATE': return 'stat-approved';
            case 'DOCUMENT_DELETE': return 'stat-amend';
            case 'DOCUMENT_UPDATE': return 'stat-pending';
            default: return 'stat-initial';
        }
    }

    /** "JB" when the admin is still on file, their id when the account is gone. */
    activityActor(entry: any): string {
        return entry?.adminName || entry?.adminEmail || `Admin ${entry?.adminId ?? '—'}`;
    }

    /** The document an entry was about, when it was about one. */
    activitySubject(entry: any): string {
        const changed = this.auditFieldChanges(entry);
        const type = changed.find((c) => c.label === 'Type');
        const subType = changed.find((c) => c.label === 'Sub Type');

        const typeValue = this.firstRealValue(type);
        if (!typeValue) return '—';

        const subTypeValue = this.firstRealValue(subType);
        const name = this.verifyDocumentName(typeValue) || typeValue;
        return subTypeValue && subTypeValue !== typeValue
            ? `${name} — ${this.subDocumentDictionary[subTypeValue] || subTypeValue}`
            : name;
    }

    /** New value if there is one, else the old one — a delete only has old. */
    private firstRealValue(change?: { oldValue: string; newValue: string }): string {
        if (!change) return '';
        const candidate = change.newValue && change.newValue !== '—' ? change.newValue : change.oldValue;
        return candidate && candidate !== '—' ? candidate : '';
    }

    onBookingSortChange() {
        this.fetchTransactions(this.selectedServiceType);
    }

    sendFollowUpNotification(partnerId: string, successModal: TemplateRef<any>) {
        this.coreUtils.update(SEND_FOLLOW_UP_NOTIFICATION, {
            partnerId: partnerId
        }, (data) => {
            if (data['sendFollowUpNotification'] != null) {
                this.confirmSelection['follow_up'] = true;
                this.modalService.open(successModal, { size: 'md', backdrop: 'static', keyboard: false });
                this.updatePartnerAccountStatus(partnerId, 'FOR_ADDITIONAL_DOCUMENT_SUBMISSION', successModal);
            }
        });
    }

    updatePartnerAccountStatus(partnerId: string, status: string, successModal: TemplateRef<any>) {
        this.coreUtils.update(UPDATE_PARTNER_ACCOUNT_STATUS, {
            partnerId: partnerId,
            status: status
        }, (data) => {
            if (data['updatePartnerAccountStatus']) {
                // Status updated successfully
            }
        });
    }

    onServiceTypeChange(event: any) {
        this.fetchTransactions(this.selectedServiceType);
    }

    verifyPartner(modal: TemplateRef<any>, rider_id: string) {
        // Second layer of the same guard: even if the confirmation modal was
        // forced open through the DOM, never send the approval mutation for a
        // partner that is already approved / not eligible
        if (!this.checkIfAvailableforApproval()) {
            this.closeAllModals();
            return;
        }

        this.coreUtils.update(APPROVE_PARTNER_ACCOUNT, {
            partnerId: rider_id
        }, (data) => {
            if (data['approvePartnerAccount']) {
                this.detailViewed['isApprove'] = true;
                this.detailViewed['status'] = 'approved';
                this.modalService.open(modal, { size: 'md', backdrop: 'static', keyboard: false });
            }
        });
    }

}
